import { useAuth } from 'oidc-react';
import { useTenantSelection } from '../providers/TenantSelectionProvider';
import { isOwnTenantScope, isRouteAllowedInOwnTenant, ownTenantMenus } from '../common/Utils/tenantScope';

/**
 * Whether the signed-in Globaladmin/reseller is in their own tenant scope (see `tenantScope.ts`), and what that allows.
 * For every other role, or once another tenant is selected, nothing is restricted.
 */
export const useTenantScope = () => {
  const auth = useAuth();
  const { selectedTenantId } = useTenantSelection();
  const role = (auth?.userData?.profile?.role as string | undefined) ?? 'tenantadmin';
  const ownTenantId = auth?.userData?.profile?.tenant_id as string | undefined;

  const restricted = isOwnTenantScope(role, selectedTenantId, ownTenantId);

  return {
    role,
    restricted,
    isMenuAllowed: (menuKey: string) => !restricted || ownTenantMenus(role).includes(menuKey),
    isRouteAllowed: (pathname: string) => !restricted || isRouteAllowedInOwnTenant(role, pathname),
  };
};

export default useTenantScope;
